// Default legal page contents in lightweight markdown.
// Supported syntax:
//   ## H2
//   ### H3
//   - List item
//   **bold**, [text](url)
//   --- (horizontal rule)
//   blank line = new paragraph

export const DEFAULT_IMPRESSUM = `Angaben gemäß § 5 TMG

## Betreiber der Website
**Maurizio Rogait**

## Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
**Maurizio Rogait**

## Adresse
Aus Gründen des Datenschutzes und der persönlichen Sicherheit wird keine öffentliche Postanschrift angegeben.

Die Kontaktaufnahme ist ausschließlich per E-Mail möglich:
[info@strassenwert.de](mailto:info@strassenwert.de)
Telefon: [+49 175 50 03 19 2](tel:+491755003192)

## Haftung für Inhalte
Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.

Nach §§ 8 bis 10 TMG sind wir jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.

## © Urheberrecht
Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.

## Haftung für Links
Diese Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.

Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.`;

export const DEFAULT_DATENSCHUTZ = `Wir freuen uns über dein Interesse an STRAßENWERT. Der Schutz deiner personenbezogenen Daten ist uns ein wichtiges Anliegen. Nachfolgend informieren wir dich über die Verarbeitung personenbezogener Daten bei der Nutzung dieser Website.

## 1. Verantwortlicher
Verantwortlich für die Datenverarbeitung im Sinne der DSGVO ist:
**Maurizio Rogait**
E-Mail: [info@strassenwert.de](mailto:info@strassenwert.de)
Telefon: [+49 175 50 03 19 2](tel:+491755003192)

## 2. Erhebung und Speicherung personenbezogener Daten
### Kontakt- und Bewerbungsformular
Wenn du uns über das Kontaktformular Anfragen zukommen lässt, werden deine Angaben aus dem Anfrageformular (Name, E-Mail-Adresse, Telefonnummer, Künstlername, Anfrageart, Nachricht) zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.

Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Durchführung vorvertraglicher Maßnahmen) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an effizienter Bearbeitung).

### Server-Log-Dateien
Der Provider dieser Seiten erhebt und speichert automatisch Informationen in Server-Log-Dateien (Browsertyp, Betriebssystem, Referrer-URL, Hostname, Uhrzeit der Anfrage, IP-Adresse). Eine Zusammenführung mit anderen Datenquellen findet nicht statt.

## 3. Weitergabe von Daten
Eine Übermittlung deiner personenbezogenen Daten an Dritte zu anderen als den im Folgenden aufgeführten Zwecken findet nicht statt. Wir geben deine Daten nur weiter, wenn du ausdrücklich eingewilligt hast, die Weitergabe zur Vertragserfüllung erforderlich ist oder wir gesetzlich verpflichtet sind.

## 4. Speicherdauer
Personenbezogene Daten werden nur so lange gespeichert, wie es für die Erfüllung des jeweiligen Zwecks erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen.

## 5. Deine Rechte
- Recht auf Auskunft (Art. 15 DSGVO)
- Recht auf Berichtigung (Art. 16 DSGVO)
- Recht auf Löschung (Art. 17 DSGVO)
- Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)
- Recht auf Datenübertragbarkeit (Art. 20 DSGVO)
- Widerspruchsrecht (Art. 21 DSGVO)
- Recht auf Beschwerde bei einer Aufsichtsbehörde

## 6. Cookies & Tracking
Diese Website verwendet essentielle technische Cookies, die für den Betrieb erforderlich sind. Optionales Tracking bzw. Analytics wird nur nach deiner ausdrücklichen Einwilligung aktiviert.

## 7. Social Media / Externe Links
Auf dieser Website befinden sich Links zu unseren Instagram-Profilen (@strassenwert, @strassenwert.studios). Beim Klick auf diese Links wirst du zur Website des jeweiligen Anbieters weitergeleitet. Für die dort verarbeiteten Daten gelten die Datenschutzbestimmungen der jeweiligen Plattform.

## 8. Kontakt
Bei Fragen zum Datenschutz wende dich jederzeit an: [info@strassenwert.de](mailto:info@strassenwert.de)`;

export const DEFAULT_AGB = `Allgemeine Geschäftsbedingungen (AGB) der Website STRAßENWERT, betrieben von Maurizio Rogait.

## § 1 Geltungsbereich
Diese AGB gelten für alle Dienstleistungen von STRAßENWERT im Bereich Künstlermanagement, Social Media Marketing, Promotion & PR, Content Creation, Networking, Strategie sowie Vertrieb & Marketing.

Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, wir haben ihrer Geltung ausdrücklich schriftlich zugestimmt.

## § 2 Vertragsschluss
Die Darstellungen auf dieser Website sind unverbindlich. Ein Vertrag kommt erst durch schriftliche Bestätigung beider Parteien (z. B. per E-Mail) bzw. durch Unterzeichnung einer individuellen Leistungsvereinbarung zustande.

## § 3 Leistungen und Preise
Die auf der Website angegebenen Preise sind unverbindliche Startpreise. Endgültige Pakete und Preise werden individuell im Beratungsgespräch zwischen STRAßENWERT und Kunde vereinbart.

Alle Preise verstehen sich, soweit nicht anders angegeben, zzgl. der gesetzlichen Umsatzsteuer.

## § 4 Zahlungsbedingungen
Sofern nicht anders vereinbart, sind Rechnungen innerhalb von 14 Tagen nach Rechnungsdatum ohne Abzug zahlbar. Bei Retainer-Modellen erfolgt die Zahlung jeweils zum Monatsanfang im Voraus.

## § 5 Mitwirkungspflichten des Kunden
- rechtzeitige Bereitstellung aller für die Leistungserbringung erforderlichen Inhalte, Zugänge und Materialien
- Einhaltung abgestimmter Zeitpläne (z. B. Release-Daten, Content-Approvals)
- Zusicherung, dass bereitgestellte Inhalte frei von Rechten Dritter sind

## § 6 Urheber- und Nutzungsrechte
Von STRAßENWERT erstellte Inhalte (Visuals, Konzepte, Strategien) unterliegen dem Urheberrecht. Nutzungsrechte werden erst nach vollständiger Bezahlung der vereinbarten Vergütung im vertraglich festgelegten Umfang übertragen.

## § 7 Haftung
STRAßENWERT haftet nur für Schäden, die auf Vorsatz oder grober Fahrlässigkeit beruhen. Bei leichter Fahrlässigkeit haften wir nur bei Verletzung wesentlicher Vertragspflichten und begrenzt auf den vertragstypischen, vorhersehbaren Schaden.

Für den Erfolg von Marketing-, Promotion- oder Release-Maßnahmen (z. B. Streamzahlen, Follower-Wachstum, Chart-Platzierungen) wird keine Garantie übernommen, da dieser u. a. von künstlerischen, marktbezogenen und plattformseitigen Faktoren abhängt.

## § 8 Vertragslaufzeit und Kündigung
Laufzeit und Kündigungsfristen ergeben sich aus der jeweiligen Individualvereinbarung. Soweit nichts abweichend vereinbart ist, können monatliche Retainer mit einer Frist von 30 Tagen zum Monatsende gekündigt werden.

## § 9 Vertraulichkeit
Beide Parteien verpflichten sich, alle im Rahmen der Zusammenarbeit bekannt gewordenen vertraulichen Informationen auch über das Vertragsende hinaus vertraulich zu behandeln.

## § 10 Schlussbestimmungen
Es gilt deutsches Recht. Gerichtsstand ist, soweit gesetzlich zulässig, Berlin. Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.

---

Fragen zu diesen AGB? [info@strassenwert.de](mailto:info@strassenwert.de)`;
